import React from 'react';
import Contact from '../components/Contact';
import Marquee from '../components/Marquee';

function ContactPage() {
  return (
    <>
      <Contact />
      <Marquee />
    </>
  );
}

export default ContactPage;